
import { useRouter } from 'vue-router'

import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Button from '@/components/elements/Button.vue'

export default {
  name: 'FaqContact',
  components: {
    HeadingLv3,
    Button
  },
  setup() {
    const router = useRouter()

    const toContact = () => {
      router.push({ path: '/contact/input' })
    }

    return {
      toContact
    }
  }
}
